import React from "react";

const RubberDuck = ({ flip = false, ...rest }) => (
  <svg
    viewBox="0 0 120 100"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{
      width: "100%",
      height: "auto",
      display: "block",
      transform: flip ? "scaleX(-1)" : undefined,
    }}
    {...rest}
  >
    <defs>
      <radialGradient id="rd-body" cx="38%" cy="28%" r="85%">
        <stop offset="0%" stopColor="#FFE876" />
        <stop offset="55%" stopColor="#FFC619" />
        <stop offset="100%" stopColor="#D88A00" />
      </radialGradient>
      <radialGradient id="rd-head" cx="32%" cy="28%" r="80%">
        <stop offset="0%" stopColor="#FFEC8A" />
        <stop offset="60%" stopColor="#FFC619" />
        <stop offset="100%" stopColor="#E89A00" />
      </radialGradient>
      <linearGradient id="rd-beak" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#FF9A1A" />
        <stop offset="100%" stopColor="#D85800" />
      </linearGradient>
    </defs>

    {/* tail */}
    <path d="M 102 52 L 118 40 L 110 64 Z" fill="#D88A00" />

    {/* body */}
    <ellipse cx="62" cy="64" rx="48" ry="22" fill="url(#rd-body)" />

    {/* belly highlight */}
    <ellipse cx="50" cy="74" rx="34" ry="9" fill="#FFE26A" opacity="0.55" />

    {/* wing */}
    <path
      d="M 56 56 Q 78 42 96 58 Q 90 78 56 70 Z"
      fill="#D88A00"
      opacity="0.55"
    />
    <path
      d="M 60 60 Q 78 50 92 62"
      stroke="#B07300"
      strokeWidth="0.8"
      fill="none"
      opacity="0.5"
    />

    {/* head */}
    <circle cx="38" cy="34" r="25" fill="url(#rd-head)" />

    {/* head highlight */}
    <ellipse cx="28" cy="22" rx="10" ry="5.5" fill="#FFF3B0" opacity="0.75" />

    {/* upper beak */}
    <path
      d="M 17 30 Q 1 28, 0 38 Q 4 44, 17 40 Z"
      fill="url(#rd-beak)"
    />
    {/* lower beak shadow */}
    <path
      d="M 0 38 Q 6 43, 17 40 L 17 42 Q 6 45, 0 39 Z"
      fill="#B85200"
      opacity="0.55"
    />

    {/* eye */}
    <circle cx="32" cy="28" r="3.6" fill="#0a2a4a" />
    <circle cx="33.2" cy="26.6" r="1.3" fill="#fff" />

    {/* water reflection just under body */}
    <ellipse cx="62" cy="89" rx="38" ry="2.2" fill="#fff" opacity="0.3" />
  </svg>
);

export default RubberDuck;
